module.exports = __webpack_public_path__ + "img/envio.e0c4518e.svg";